import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table"
}
const _hoisted_2 = ["onMouseover"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["data-count"]
const _hoisted_5 = {
  key: 2,
  class: "has-canceled",
  title: "Есть отмененные смены"
}

import {useStore} from "vuex";
import {computed, ref} from "vue";
import { DateKeys, NewUser, TimeRange } from '@/types';
import VitaShiftControl from "@/components/VitaShiftControl.vue";
import VitaVacationType from "@/components/VitaVacationType.vue";
import VitaTimeSlot from '@/components/VitaTimeSlot.vue';
import isBefore from "date-fns/isBefore";
import { addDays, isAfter, parse, startOfDay } from 'date-fns';


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaMainTable',
  setup(__props) {

const store = useStore<Storage>()

const users = computed<NewUser[]>(() => {
  return store.getters['data/pharmUsers']
})

const hoverRow = (index: number) => {
  store.commit('hoverRow', index)
}

const hover = computed<null | number>(() => {
  return store.getters['hover']
})

const dateArr = computed<DateKeys[]>(() => {
  return store.getters['data/timeScheduleKeys']
})

const isGurvRole = computed<boolean>(() => {
  return store.getters['getGurvRole']
})

const currentDate = ref<Date>(new Date())

const shiftModalPosition = (dateIndex:number, dateLength:number, userIndex:number, userLength:number): string => {
  let topPosition = userLength - 4 > userIndex ? 'top' : 'bottom'
  if (userLength > 4 && (userIndex === 2 || userIndex === 3)) {
    topPosition = 'center'
  }
  // У всех сотрудников на первой и второй строчке графика модалка открывается вниз
  if (userIndex <= 1) {
    topPosition = 'top'
  }

  const leftPosition = dateLength - 6 > dateIndex && elementLeft.value ? 'left' : 'right'

  // Последним параметром добавлен CSS класс для вложенных всплывающих элементов (фикс выхода за пределы графика)
  const menuLeftPosition = dateLength === (dateIndex + 1) ? 'm-right' : ''
  return `${leftPosition} ${topPosition} ${menuLeftPosition}`
}

const elementLeft = ref<boolean>(false)
const openShifts = (event: MouseEvent, item:number[], open:boolean) => {
  if (open) return

  const targetElement = event.target as HTMLElement;
  elementLeft.value = targetElement.getBoundingClientRect().right - window.innerWidth <= -580
  store.commit('data/closeCreateShift')
  store.commit('data/openCreateShift', item)
}

// Проверка на КМ в выбранный день
const isVacationOnDay = (timeShift, item) => {
  return Boolean(timeShift?.[item.key]?.length)
}

// Получение классов для оформления ячейки в таблице в зависимости от статуса дня
const getCellClassNames = (item, dateArrItem, user) => {
  const classMap = {
    'active': item,
    'dayOut': dateArrItem.dayOut,
    'holiday': dateArrItem.holiday,
    'today': dateArrItem.today,
    "user-inactive": isInactive(dateArrItem, user.dateOfEmployment, user.dateDismissal)
  };

  // Фильтруем по условиям и получаем названия классов
  return Object.entries(classMap).filter((entry) => entry[1]).map(([className]) => className);
}

// Проверяем на наличие смен со статусом Canceled и MissAccepted (OMR-3385)
const hasCanceledShifts = (arr: TimeRange[]) => {
  if (!arr) return false
  return arr.some(shift => shift.status === "Canceled" || shift.status === "MissAccepted");
}

// Проверяем что дата не входит в период отсутствия трудоустройства
const isInactive = (date: DateKeys, dateOfEmployment?: string | null, dateDismissal?: string | null): boolean => {
  if (!date || !date.key) return false

  // Приводим даты к формату и устанавливаем начало дня у текущего (date.key)
  const parsedCellDate = startOfDay(parse(date.key, "dd.MM.yyyy", new Date()));
  const parsedDateDismissal = dateDismissal ? new Date(dateDismissal) : null;
  const parsedDateEmployment = dateOfEmployment ? new Date(dateOfEmployment) : null;

  // Если есть дата трудоустройства, то закрашиваем все ячейки до этой даты
  if (parsedDateEmployment) {
    const actualDateEmployment = addDays(parsedDateEmployment, -1)
    if (isBefore(parsedCellDate, actualDateEmployment)) return true
  }

  // Если есть дата увольнения, то закрашиваем все ячейки начиная с этой даты
  if (parsedDateDismissal && isAfter(parsedCellDate, parsedDateDismissal)) return true

  return false
}

return (_ctx: any,_cache: any) => {
  return (dateArr.value)
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user, userIndex) => {
            return (_openBlock(), _createElementBlock("tr", {
              onMouseover: ($event: any) => (hoverRow(userIndex)),
              class: _normalizeClass({hover: hover.value === userIndex}),
              key: user.zupGuid
            }, [
              (user.dateArr)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(user.dateArr, (item, position) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: item.key + user.id,
                      class: _normalizeClass(getCellClassNames(item.openCreateShift, dateArr.value[position], user)),
                      onClick: ($event: any) => (openShifts($event, [position, userIndex], item.openCreateShift)),
                      "data-qa": "main-table-cell-open-shift"
                    }, [
                      (user.timeShift)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "table__cell-body table__cell",
                            "data-count": (user.timeShift[item.key] && user.timeShift[item.key].length > 2) ? user.timeShift[item.key].length : null
                          }, [
                            (item.openCreateShift && currentDate.value)
                              ? (_openBlock(), _createBlock(VitaShiftControl, {
                                  key: 0,
                                  user: user,
                                  date: item.key,
                                  position: shiftModalPosition(position, user.dateArr.length, userIndex, users.value.length),
                                  "show-create": !isVacationOnDay(user.timeShift, item),
                                  "is-user-inactive": isInactive(dateArr.value[position], user.dateOfEmployment, user.dateDismissal)
                                }, null, 8, ["user", "date", "position", "show-create", "is-user-inactive"]))
                              : _createCommentVNode("", true),
                            (isVacationOnDay(user.timeShift, item) && user.timeShift[item.key].length > 0)
                              ? (_openBlock(), _createBlock(VitaVacationType, {
                                  key: 1,
                                  "vacation-obj": user.timeShift[item.key][0][0]
                                }, null, 8, ["vacation-obj"]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.timeShift[item.key], (time, index) => {
                              return (_openBlock(), _createBlock(VitaTimeSlot, {
                                time: time,
                                key: `T-${time.id}`,
                                index: index,
                                shiftsLength: user.timeShift[item.key].length
                              }, null, 8, ["time", "index", "shiftsLength"]))
                            }), 128)),
                            (isGurvRole.value && hasCanceledShifts(user.timeShift[item.key]))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Отмен. смены "))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_4))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_3))
                  }), 128))
                : _createCommentVNode("", true)
            ], 42, _hoisted_2))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})